module.exports = __webpack_public_path__ + "img/story020@2x.86b84cf7.webp";